import React from '../../vendor/react';
import { useState } from '../../vendor/react';
import { Outlet, useLocation } from '../../vendor/react-router-dom';
import { AppHeader } from './AppHeader';
import { AppSidebar } from './AppSidebar';
import { useSaas } from '../../features/saas/useSaas';
import { MobileBottomNav } from './MobileBottomNav';

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const saas = useSaas();
  const location = useLocation();
  const readOnly = saas.readOnly && !['/app/plan','/app/cuenta','/app/sincronizacion'].some((path)=>location.pathname.startsWith(path));
  return (
    <div className="app-shell">
      <AppSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="app-shell__main">
        <AppHeader onOpenMenu={() => setSidebarOpen(true)} />
        {readOnly&&<div className="subscription-readonly-banner"><strong>Prueba terminada: modo de solo lectura</strong><span>Consulta tu información o elige un plan para continuar operando.</span></div>}<main className={`app-content ${readOnly?'is-readonly':''}`}><Outlet /></main>
        <MobileBottomNav onOpenMenu={() => setSidebarOpen(true)} />
      </div>
    </div>
  );
}
